export default __webpack_public_path__ + "static/media/world1.b844a57f.jpg";